module.exports = __webpack_public_path__ + "img/barricade.051acad9.png";